import LogoApp from '@/components/LayoutApp/HeaderBar/LogoApp'
import CloseSessionButton from '@/components/LayoutApp/CloseSessionButton'
import DarkModeButton from '@/components/LayoutApp/HeaderBar/DarkModeButton'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'
import { useSession } from 'next-auth/react'

const HeaderApp = () => {
  const { showThemeIcon, showCloseIcon } = useDeliveryAppContext()
  const { status } = useSession()
  const isAuth = status === 'authenticated'

  return (
    <header className="dark:shadow-none dark:border-b dark:border-gray-darkMode dark:bg-black-darkMode h-14 rounded-b-2xl fixed top-0 z-50 flex items-center justify-center w-full p-1 bg-white border-b">
      <div
        className={`w-full max-w-3xl flex flex-row ${
          showThemeIcon || showCloseIcon ? 'justify-between' : 'justify-center'
        } items-center m-auto`}
      >
        {showThemeIcon && <DarkModeButton />}
        <LogoApp />
        <div className="w-10">
          {showCloseIcon && isAuth && <CloseSessionButton />}
        </div>
      </div>
    </header>
  )
}

export default HeaderApp
